import { RegionalScope } from "@sp-crm/core";

interface EventTypeSettingsCopy {
    path: string;
    linkText: string;
    description: string;
}

const eventTypeSettings: Record<RegionalScope["kind"], EventTypeSettingsCopy> = {
    agencyWide: {
        path: "/settings/agency/tasks",
        linkText: "Add event types in Agency settings",
        description: "under Agency settings, Activity types.",
    },
    office: {
        path: "/settings/region/activity-types",
        linkText: "Add event types in Office settings",
        description: "under Office settings, Activity types.",
    },
};

export const noEventTypesText = "No event types have been set up yet.";

export const eventTypeSettingsPath = (location: RegionalScope["kind"]): string =>
    eventTypeSettings[location].path;

export const addEventTypesLinkText = (location: RegionalScope["kind"]): string =>
    eventTypeSettings[location].linkText;

export const askAdministratorText = (location: RegionalScope["kind"]): string =>
    `Ask an administrator to add them ${eventTypeSettings[location].description}`;
